export const generateColumns = (data) => {
  if (data.length === 0) return [];
  return Object.keys(data[0]).map((key) => ({
    field: key,
    headerName: key.charAt(0).toUpperCase() + key.slice(1),
    width: 130,
  }));
};
